var React = require('react');

function PencilInline (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("g",{"id":"cosigner","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"md-create","fill":"#434345","fillRule":"nonzero"},React.createElement("path",{"d":"M0,11.0833333 L0,14 L2.91666667,14 L11.5108802,5.40571354 L8.59425,2.48911979 L0,11.0833333 Z M13.7667396,3.14992708 C14.0777656,2.83890104 14.0777656,2.372125 13.7667396,2.06109896 L11.938901,0.233260417 C11.627875,-0.077765625 11.161099,-0.077765625 10.8500729,0.233260417 L9.41113542,1.67223437 L12.3277656,4.58882812 L13.7667396,3.14992708 L13.7667396,3.14992708 Z","id":"Shape"})))]);
}

PencilInline.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = PencilInline;

PencilInline.default = PencilInline;
